import EventBus from "@/utils/EventBus";

export type NotifyPayload = {
  text: string | string[];
  type: string;
  isTranslate?: boolean;
};

export function notify(payload: NotifyPayload) {
  EventBus.emit("show-notications", payload);
}

export function notifyApiError(error: {
  messages?: string[];
  code?: string;
}) {
  notify({
    text: error.messages?.flatMap((message) => message.split(",")) ?? [
      "Unknown error",
    ],
    type: "error",
  });
}
